import { FC, useMemo } from 'react';
import styles from './SamplePlanTable.module.scss';
import {
  optionSet,
  TableOptions,
  useSamplePlanTableContext,
} from '@/components/Samples/SamplePlanTable/SamplePlanTableProvider';
import { Header } from './Header';
import { SampleDefinitionRow } from './SampleDefinitionRow';
import { compareSampleDefinitionsByName } from './SamplePlanTable.utils.tsx';

export const SamplePlanTable: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { sample_definition_rows, active_details, active_metadata, table_options } = useSamplePlanTableContext();
  const gridTemplateColumns = useMemo(
    () =>
      [
        ...Array.from({ length: Number(optionSet(TableOptions.display_selection_column, table_options)) }).fill(
          'var(--table-selection-column)'
        ),
        'var(--table-expand-column)',
        'var(--table-sample-name-column)',
        'var(--table-group-column)',
        ...Array.from({ length: Number(optionSet(TableOptions.display_planned_animal_column, table_options)) }).fill(
          'var(--table-planned-animal-column)'
        ),
        ...Array.from({ length: Number(optionSet(TableOptions.display_registered_animal_column, table_options)) }).fill(
          'var(--table-registered-animal-column)'
        ),
        ...(optionSet(TableOptions.collected_samples_count, table_options)
          ? ['var(--table-planned-samples-count)', 'var(--table-collected-samples-count)']
          : []),
        'var(--table-sample-type-column)',
        'var(--table-timepoints-column)',
        ...Array.from({
          length: Number(!optionSet(TableOptions.hide_calculate_collection_time_column, table_options)),
        }).fill('var(--table-calculate-collection-time-column)'),
        ...Array.from({ length: active_details.size }).fill('var(--table-detail-column)'),
        ...Array.from({ length: active_metadata.size }).fill('var(--table-metadata-column)'),
      ].join(' '),
    [active_details, active_metadata, table_options]
  );
  return (
    <div
      className={styles.SamplePlanTable}
      style={{ gridTemplateColumns }}
      data-test-component="SamplePlanTable"
      data-test-element="container"
      {...props}
    >
      <Header data-test-component="Header" data-test-element="container" />
      {Array.from(sample_definition_rows.values())
        .sort(compareSampleDefinitionsByName)
        .map((data) => (
          <SampleDefinitionRow key={data.api_id} data={data} />
        ))}
    </div>
  );
};
